import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useCallback, useState } from "react";
import { v4 } from "uuid";
import { storage } from "../firebase/firebase";

const useUploadMultiple = (type = "property") => {
  const [images, setImages] = useState([]);
  const [uploadImage, setUploadImage] = useState(null);

  const uploadFile = useCallback(
    (imageUpload) => {
      if (imageUpload == null) return;
      const imageRef = ref(storage, `${type}/${v4()}${imageUpload.name}`);
      uploadBytes(imageRef, imageUpload).then((snapshot) => {
        getDownloadURL(snapshot.ref).then((url) => {
          setImages((prev) => [...prev, url]);
        });
      });
    },
    [type]
  );

  const removeAll = () => {
    setImages([]);
    setUploadImage(null);
  };

  return { uploadFile, images, removeAll, setImages, uploadImage, setUploadImage };
};

export default useUploadMultiple;
